export { default } from './OnboardingPeopleInput';
export { residentTextToNumber } from './reducer';
